var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-news-form',{ref:"form",staticClass:"pt-news-form__withData",attrs:{"id":_vm.id,"newsCategories":_vm.newsCategories,"newsDetail":_vm.newsDetail,"content":_vm.newsContent,"isEdit":_vm.isEdit},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }